<template>
  <Teleport v-if="type === 'image' && url" to="body">
    <div class="library-image-viewer">
      <ElImageViewer :url-list="[url]" hide-on-click-modal @close="emit('close')" />
    </div>
  </Teleport>
  <el-dialog v-else :model-value="true" :title="name" class="library-media-viewer" width="960px" align-center append-to-body destroy-on-close @close="emit('close')">
    <div v-if="!url || failed" class="library-media-error">暂时无法预览此素材</div>
    <video v-else-if="type === 'video'" :key="url" :src="url" controls playsinline preload="metadata" @error="failed = true" />
    <audio v-else :key="url" :src="url" controls preload="metadata" @error="failed = true" />
  </el-dialog>
</template>

<script setup>
/* global defineProps, defineEmits */
import { computed, ref, watch } from 'vue'
import { ElImageViewer } from 'element-plus'
import { assetDisplayName, assetMediaType } from '../model/assetLibrarySelection'
const props = defineProps({ item: { type: Object, default: null } })
const emit = defineEmits(['close'])
const type = computed(() => props.item ? assetMediaType(props.item) : '')
const name = computed(() => props.item ? assetDisplayName(props.item) : '')
const url = computed(() => props.item ? [props.item.mediaUrl, props.item.sourceUrl, props.item.coverUrl, props.item.localUrl, props.item.url]
  .find(value => value && !String(value).startsWith('asset://')) || '' : '')
const failed = ref(false)
watch(url, () => { failed.value = false })
</script>

<style scoped>
.library-image-viewer :deep(.el-image-viewer__mask) { opacity: 1; background: rgb(8 8 8 / 78%); -webkit-backdrop-filter: blur(16px); backdrop-filter: blur(16px); }
:global(.library-media-viewer.el-dialog) { max-width: calc(100vw - 32px); border: 1px solid #454545; border-radius: 18px; background: #212121; --el-text-color-primary: #eee; --el-text-color-regular: #ccc; }
.library-media-viewer video { display: block; width: 100%; max-height: 75vh; background: #141414; }
.library-media-viewer audio { display: block; width: 100%; }
.library-media-error { padding: 40px; color: #aaa; text-align: center; }
</style>
